import { useSessionStorage } from 'usehooks-ts';
import { OrderTypeEnum } from './types';
import { useMemo } from 'react';

export const useSyncOrdersList = (): [OrderTypeEnum, (type: OrderTypeEnum) => void] => {
  const [storageOrderType, updateStorageOrderType] = useSessionStorage('webtrader:spot:order:type', OrderTypeEnum.OPEN);

  return useMemo(() => [storageOrderType, updateStorageOrderType], [storageOrderType, updateStorageOrderType]);
};